import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class FarmHasWorkModel extends BaseModel {

    constructor() {
        super({
                name: "farm_has_work",
                tableName: 'farm_has_work',
                label: "Trang trại có công việc",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                farm_id: { 
                    name: 'farm_id',
                    display: false
                },
                work_id: { 
                    name: 'work_id',
                    display: false
                }

            },
            )
    }

}